import styled from "styled-components";
import { Dialog } from "@mui/material";

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 700px;
    max-width: 800px;
    padding: 32px 40px;
    border-radius: 8px;
  }
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 0;
`;

export const IconWrapper = styled.div`
  margin-bottom: 24px;
  color: ${props => props.theme.colors.successGreen};
`;

export const SuccessTitle = styled.h2`
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.25px;
  color: ${props => props.theme.colors.darkGray};
  margin: 0 0 16px 0;
`;

export const SuccessDescription = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: ${props => props.theme.colors.darkGray};
  margin: 0;
`;

export const DialogFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 24px;
  border-top: 1px solid ${props => props.theme.colors.dividerGray};
  margin-top: 16px;
`;

export const AddMoreButton = styled.button`
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.davysGrey};
  background: transparent;
  border: 1px solid ${props => props.theme.colors.dividerGray};
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.highClearGray};
  }
`;

export const GoToVaultButton = styled.button`
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  color: white;
  background: ${props => props.theme.colors.celticBlue};
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const UsersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  align-items: flex-start;
  gap: 24px;
  border-radius: 16px;
  border: 1px solid ${props => props.theme.colors.highClearGray};
  margin-top: 16px;
  width: 100%;
  padding: 16px 25px 14px 55px;
`;

export const UserName = styled.span`
  ${props => props.theme.fonts.variant.medium()};
  color: ${props => props.theme.colors.primary};
  flex: 0 0 calc(33.33% - 16px);
  text-align: left;
  font-weight: 600;
`; 